import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SuppressScrollEventDirective } from "./suppress-scroll-event.directive";

@NgModule({
  declarations: [SuppressScrollEventDirective],
  imports: [CommonModule],
  exports: [SuppressScrollEventDirective],
})
export class SuppressScrollEventModule {}
